import { regionsSelector } from '@app/store/selectors/regions'
import { createThunk } from '@app/store/thunk'

import { getRegionByLocation } from './region'

type Region = ReturnType<typeof regionsSelector>[number]

interface RegionMatch {
  region: Region | null
  coordinates: GeolocationCoordinates
}

/** Returns client city based on Geolocation API */
export function requestRegion() {
  return createThunk<Promise<RegionMatch | null>>(async (dispatch, getState) => {
    if (!IS_BROWSER) return Promise.resolve(null)
    if (!('geolocation' in window.navigator)) return Promise.resolve(null)
    const position = await new Promise<GeolocationPosition>((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        position => {
          resolve(position)
        },
        err => {
          reject(err)
        },
        {
          enableHighAccuracy: true,
        }
      )
    })

    const resolved = await dispatch(getRegionByLocation(position.coords.latitude, position.coords.longitude))
    const region = regionsSelector(getState()).find(r => r.id === resolved.id) ?? null

    return { region, coordinates: position.coords }
  })
}
